import { H4, UL } from "../../../../AbstractElements";
import { MixLayout } from "../../../../Constant";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { setMixBackgroundLayout } from "../../../../Redux-Toolkit/Reducers/ThemeCustomizerSlice";
import ConfigDB from "../../../../config/ThemeConfig";
import BgDark from "./BgDark";
import BgLight from "./BgLight";
import DarkSidebar from "./DarkSidebar";

const MixLayoutComponent = () => {
  const dispatch = useAppDispatch();
  const mixLayout = ConfigDB.data.color.mix_background_layout;

  const addMixBackgroundLayout = (mix_background_layout: string) => {
    ConfigDB.data.color.mix_background_layout = mix_background_layout;
    dispatch(setMixBackgroundLayout(mix_background_layout));
  };

  const handleCustomizerMix_Background = (value: string) => {
    addMixBackgroundLayout(value);
    if (value === "light-only") {
      document.body.classList.add("light-only");
      document.body.classList.remove("dark-sidebar");
      document.body.classList.remove("dark-only");
      ConfigDB.data.color.mix_background_layout = "light-only"
    } else if (value === "dark-sidebar") {
      document.body.classList.remove("light-only");
      document.body.classList.add("dark-sidebar");
      document.body.classList.remove("dark-only");
      ConfigDB.data.color.mix_background_layout = "dark-sidebar"
    } else if (value === "dark-only") {
      document.body.classList.remove("light-only");
      document.body.classList.remove("dark-sidebar");
      document.body.classList.add("dark-only");
      ConfigDB.data.color.mix_background_layout = "dark-only"
    }
  };

  return (
    <>
      <H4>{MixLayout}</H4>
      <UL className="layout-grid customizer-mix simple-list d-flrx flex-row">
        <BgLight mixLayout={mixLayout} handleCustomizerMix_Background={handleCustomizerMix_Background} />
        <DarkSidebar mixLayout={mixLayout} handleCustomizerMix_Background={handleCustomizerMix_Background} />
        <BgDark handleCustomizerMix_Background={handleCustomizerMix_Background} mixLayout={mixLayout} />
      </UL>
    </>
  );
};

export default MixLayoutComponent;
